export enum BankConnectionStatus {
    NOT_ACTIVE = 'NOT_ACTIVE',
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    ERROR = 'ERROR'
}

export enum StatementFetchInterval {
    DONT_FETCH = 'DONT_FETCH',
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    DAILY_WITH_WEEKLY_SUMMARY = 'DAILY_WITH_WEEKLY_SUMMARY',
}

export enum StatementDownloadStatus {
    INITIATED = 'INITIATED',
    STATEMENT_REQUESTED = 'STATEMENT_REQUESTED',
    ALL_STATEMENT_FETCHED = 'ALL_STATEMENT_FETCHED',
    FINISHED = 'FINISHED',
    ERROR = 'ERROR',
    INTERRUPTED = 'INTERRUPTED',
}